import React, { useContext } from 'react';
import { MainContext } from '../../context/MainContext';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';

import TitleOutlinedIcon from '@mui/icons-material/TitleOutlined';
import CropFreeOutlinedIcon from '@mui/icons-material/CropFreeOutlined';
import TerminalOutlinedIcon from '@mui/icons-material/TerminalOutlined';
import DeviceThermostatOutlinedIcon from '@mui/icons-material/DeviceThermostatOutlined';
import LocalFireDepartmentOutlinedIcon from '@mui/icons-material/LocalFireDepartmentOutlined';

export default function DashboardSpaDetails() {
  const state = useContext(MainContext).state;

  const r2 = state.R2.split(',');
  const r3 = state.R3.split(',');
  const r6 = state.R6.split(',');

  const type = r3[7];
  const serial = `${r3[8]} ${r3[9]}`;
  const software = r3[6];
  const stmp = `${(r6[8] / 10).toFixed(1)}°C`;
  const heater = `${(r2[12] / 10).toFixed(1)}°C`;

  const textValueColour = 'text.disabled';

  return (
    <React.Fragment>
      <Typography
        component="h2"
        variant="h6"
        color="white"
        gutterBottom
        sx={{ fontWeight: 600 }}
      >
        Spa Details
      </Typography>

      <Grid container spacing={1.5}>
        {[
          { label: 'Type', icon: <TitleOutlinedIcon />, value: type },
          { label: 'Serial', icon: <CropFreeOutlinedIcon />, value: serial },
          { label: 'Software Version', icon: <TerminalOutlinedIcon />, value: software },
        ].map((item, idx) => (
          <Grid item xs={12} key={idx}>
            <Paper
              sx={{
                p: 1.5,
                height: 60,
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                borderRadius: 2,
                bgcolor: 'rgba(255,255,255,0.04)',
                border: '1px solid rgba(255,255,255,0.08)',
                transition: '0.2s ease',
                '&:hover': {
                  bgcolor: 'rgba(255,255,255,0.08)',
                  transform: 'translateY(-2px)',
                },
              }}
            >
              {/* Icon bubble */}
              <Box
                sx={{
                  width: 32,
                  height: 32,
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  bgcolor: 'rgba(255,255,255,0.05)',
                  color: 'rgba(50,116,162,1)',
                }}
              >
                {item.icon}
              </Box>

              {/* Text */}
              <Box sx={{
                flexGrow: 1,
                minWidth: 0,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                gap: 0.3,
                mt: 0.4
              }}>
                <Typography sx={{ fontSize: 14, fontWeight: 700 }} color="white" noWrap>
                  {item.label}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: textValueColour,
                    fontSize: 13,
                  }}
                  noWrap
                >
                  {item.value}
                </Typography>
              </Box>
            </Paper>
          </Grid>
        ))}

        <Grid item xs={6}>
          <Paper
            sx={{
              p: 1.5,
              height: 60,
              display: 'flex',
              alignItems: 'center',
              gap: 1.5,
              borderRadius: 2,
              bgcolor: 'rgba(255, 255, 255, 0.04)',
              border: '1px solid rgba(255,255,255,0.1)',
              transition: '0.2s ease',
              '&:hover': {
                bgcolor: 'rgba(255,255,255,0.08)',
                transform: 'translateY(-2px)',
              },
            }}
          >
            <Box
              sx={{
                width: 32,
                height: 32,
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                bgcolor: 'rgba(30,136,229,0.9)',
                color: '#000',
              }}
            >
              <DeviceThermostatOutlinedIcon fontSize="small" />
            </Box>

            <Box sx={{ flexGrow: 1 }}>
              <Typography sx={{ fontSize: 14, fontWeight: 700 }} color="white">
                STMP
              </Typography>
              <Typography sx={{ color: textValueColour, fontSize: 13 }}>
                {stmp}
              </Typography>
            </Box>
          </Paper>
        </Grid>

        <Grid item xs={6}>
          <Paper
            sx={{
              p: 1.5,
              height: 60,
              display: 'flex',
              alignItems: 'center',
              gap: 1.5,
              borderRadius: 2,
              bgcolor: 'rgba(255, 255, 255, 0.04)',
              border: '1px solid rgba(255,255,255,0.1)',
              transition: '0.2s ease',
              '&:hover': {
                bgcolor: 'rgba(255,255,255,0.08)',
                transform: 'translateY(-2px)',
              },
            }}
          >
            <Box
              sx={{
                width: 32,
                height: 32,
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                bgcolor: 'rgba(255,112,67,0.9)',
                color: '#000',
              }}
            >
              <LocalFireDepartmentOutlinedIcon fontSize="small" />
            </Box>

            <Box sx={{ flexGrow: 1 }}>
              <Typography sx={{ fontSize: 14, fontWeight: 700 }} color="white">
                Heater
              </Typography>
              <Typography sx={{ color: textValueColour, fontSize: 13 }}>
                {heater}
              </Typography>
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
